import React from "react";
import { plansData } from "../../data/plansData";
import "./Plans.css";
import "../../App.css";
import whiteTick from "../../assets/whiteTick.png";
import { motion } from "framer-motion";

const Plans = () => {
  const transition = { duration: 0.2 };

  return (
    <div className="plans-container">
      <div className="blur plans-blur-1"></div>
      <div className="blur plans-blur-2"></div>
      <div className="programs-header" style={{ gap: "rem" }}>
        <span className="stroke-text">READY TO START</span>
        <span>YOUR JOURNEY</span>
        <span className="stroke-text">NOW WITH US</span>
      </div>
      {/* plans card */}
      <div className="plans">
        {plansData.map((plan, i) => (
          <motion.div
            className="plan"
            key={i}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 1.0 }}
            transition={transition}
          >
            {plan.icon}
            <span>{plan.name}</span>
            <span>$ {plan.price}</span>

            <div className="features">
              {plan.features.map((feature, i) => (
                <div className="feature">
                  <img src={whiteTick} alt="" />
                  <span key={i}>{feature}</span>
                </div>
              ))}
            </div>

            <div>
              <span>See more benefits</span>
            </div>
            <button className="btn">Join now</button>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Plans;
